export const AGENT_REQUEST_DOCUMENT_TYPES = ['notes', 'blocks', 'userSources'] as const;

export type AgentRequestDocumentType = (typeof AGENT_REQUEST_DOCUMENT_TYPES)[number];
